import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

export const convertFormDateValueToKnmDataDate = (dateString?: string | null): string | null => {
  if (dateString) {
    return formatDate({ date: dateString, dateFormat: SYSTEM_DATE_FORMAT_FNS });
  }

  return null;
};
